interface ErrorDetails {
  message?: string;
  name?: string;
  stack?: string;
  code?: string;
  [key: string]: any;
}

export const extractErrorDetails = (error: Error | unknown): ErrorDetails => {
  if (error instanceof Error) {
    return {
      message: error.message,
      name: error.name,
      stack: error.stack,
    };
  }
  if (error && typeof error === 'object') {
    return {
      code: (error as any).code || undefined,
      message: (error as any).message || String(error),
      name: (error as any).name || 'UnknownError',
      ...(error as any),
    };
  }
  if (error) {
    return { message: String(error) };
  }
  return {};
};
